$('.page-block_collapse').each(function(index) {
    const $this = $(this);
    const $prev = $this.prev();
    const $next = $this.next();

    console.log(index + 1);
    $this.addClass( !$prev.hasClass('page-block_collapse') && $next.hasClass('page-block_collapse') ? 'page-block_collapse_first' : '' );
    $this.addClass( $prev.hasClass('page-block_collapse') && !$next.hasClass('page-block_collapse') ? 'page-block_collapse_last' : '' );

    // $($this + '.accordion__summary').attr('data-before', index + 1);
    console.log($(this).find( ".accordion__summary" ));
    $(this).find( ".accordion__summary" ).attr('data-before', index + 1);
    // $this.addClass( $prev.hasClass('page-block_collapse') && $next.hasClass('page-block_collapse') ? 'bg_cyan' : 'bg_lime' );
});
